import { useId } from 'react';
import { IconPropsType } from '..';

export const FavoritesIcon = ({ colored, ...props }: IconPropsType) => {
  // Generating unique id for the SVG definitions
  const reactId = useId();
  const gradientId = `paint0_linear_${reactId}`;
  const groupId = `FavoritesIcon_${reactId}`;

  if (colored) {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g id={groupId}>
          <path
            d="M8.53591 14.4673L5.44092 16.0957C4.95564 16.3491 4.35175 16.1657 4.09832 15.6805C3.99588 15.4863 3.96352 15.2653 3.99587 15.0496L4.58899 11.6041C4.64291 11.2806 4.53507 10.9517 4.30321 10.7252L1.80134 8.2773C1.40773 7.89447 1.39694 7.26361 1.78516 6.87C1.93614 6.71363 2.13564 6.6112 2.35671 6.57885L5.81297 6.07736C6.13648 6.02884 6.41687 5.82397 6.56245 5.5328L8.10994 2.40007C8.35258 1.9094 8.95109 1.70449 9.44176 1.94713C9.63587 2.04419 9.79763 2.20057 9.89469 2.40007L11.4422 5.5328C11.5878 5.82936 11.8681 6.02884 12.1917 6.07736L15.6479 6.57885C16.1925 6.65973 16.5699 7.16116 16.4891 7.70575C16.4567 7.92143 16.3543 8.12093 16.1979 8.2773L13.696 10.7199C13.4642 10.9463 13.3563 11.2753 13.4102 11.5988L14.0034 15.0442C14.095 15.5834 13.7338 16.101 13.1892 16.1927C12.9735 16.2304 12.7524 16.1927 12.5583 16.0903L9.46333 14.4619C9.17216 14.3109 8.82708 14.3109 8.53591 14.4619V14.4673Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <defs>
          <linearGradient
            id={gradientId}
            x1="11.8124"
            y1="6.18761"
            x2="4.49993"
            y2="16.3126"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="0.36"
              stopColor="#E2E3E4"
            />
            <stop
              offset="0.360053"
              stopColor="#E9790C"
            />
          </linearGradient>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      // fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=heart, signs=default, menus=default, casino=default, currency=default">
        <path
          id="Vector"
          d="M16.5618 10.8296L10.0017 17L3.42442 10.8189L3.41289 10.8081L3.11287 10.5227L3.12441 10.512C1.532 8.71363 1.63009 6.03227 3.42442 4.34162C5.21876 2.65096 8.09027 3.49779 10 5C11.9155 3.52472 14.7847 2.66173 16.5733 4.34162C18.3676 6.03227 18.4715 8.70825 16.8733 10.512L16.8848 10.5227L16.5848 10.8081L16.5618 10.8296Z"
          fill="#8388A3"
        />
      </g>
    </svg>
  );
};
